import type { TranslateFunction } from "ra-core";

import type { Lead, LeadSource } from "../types";

/** where leads come from, in the order of the filter (crm/db/13_leads.sql) */
export const LEAD_SOURCES: LeadSource[] = [
  "call",
  "site",
  "avito",
  "drom",
  "email",
  "other",
];

export const leadSourceChoices = (translate: TranslateFunction) =>
  LEAD_SOURCES.map((id) => ({
    id,
    name: translate(`crm.leads.sources.${id}`),
  }));

/** how a lead is called in lists and links */
export const leadRepresentation = (lead: Lead) =>
  lead.name?.trim() ||
  lead.company_name?.trim() ||
  lead.phone ||
  lead.email ||
  `№${lead.id}`;
